import type { NavigationItem } from '@hetivo/hetivo-lib-web-utils';

import { SERVICE_REMINDERS_PATH } from '../paths';

/**
 * Sets the Overdue-reminder count on the sidebar's Reminders item (SWOOP-281, decision #24). Returns a new
 * array so the input is never mutated; every other item is passed through unchanged. A `count` of
 * `undefined` (not entitled, no permission, not yet loaded or a failed request) or 0 leaves the item
 * without a badge.
 */
export function applyRemindersBadge(
  items: NavigationItem[],
  count: number | undefined,
  label: string,
): NavigationItem[] {
  if (count === undefined || count <= 0) {
    return items;
  }
  return items.map((item) =>
    item.path === SERVICE_REMINDERS_PATH ? { ...item, badgeCount: count, badgeCountLabel: label } : item,
  );
}
